import React from 'react';
import './Styles/Feedback.css';
import v2 from "./imgs/review2.mp4";
import v3 from "./reviews/review3.mp4";
import p1 from "./imgs/pic1.jpeg";
import p2 from "./imgs/pic2.jpeg";
import p3 from "./imgs/pic3.jpeg";

function Feedback() {
    return (
        <div className="feedback-container">
            <div className="feedback-header">
                <h1>Customer Feedback</h1>
                <p>Hear from our community of makers and creators!</p>
            </div>

            <section className="testimonials-section">
                <h2>Testimonials</h2>
                <div className="testimonials">
                    <div className="testimonial">
                        <p>"Hi Bhavika, Thank you for such a wonderful crochet class! I really enjoyed the sessions and appreciate how helpful and patient you were throughout the course. I’m proud to have picked up a new skill so quickly, thanks to your guidance! 🐝 "</p>
                        <span>- Sanika junjunwala</span>
                    </div>
                    <div className="testimonial">
                        <p>"Thank you so much maam for this incredible experience! As I mentioned, when I first started making the bee, I felt overwhelmed and almost gave up. However, your encouragement and guidance motivated me to push through and finish the project.

I’m so glad I continued—completing the bee has been such a rewarding accomplishment. I know my baby will be so proud of me! ❤️ Your patience and support made all the difference. Thank you for sharing your passion and helping me create something special!"</p>
                        <span>- Shruti Patel</span>
                    </div>
                    <div className="testimonial">
                        <p>"I love their sustainable yarns. Knowing they care about the environment makes every project more meaningful."</p>
                        <span>- Tej Kiran</span>
                    </div>
                </div>
            </section>

            <section className="videos-section">
                <h2>Community Videos</h2>
                <div className="videos">
                    <div className="video-card">
                        <video controls width="320" height="240">
                            <source src={v2} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                        <p>Customer Project Highlight - Hand-Knitted Elephant</p>
                    </div>
                    <div className="video-card">
                        <video controls width="320" height="240">
                            <source src={v3} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                        <p>Yarn Knitting Workshop Recap</p>
                    </div>
                </div>
            </section>

            <section className="photos-section">
                <h2>Project Gallery</h2>
                <div className="photos">
                    <div className="photo-card">
                        <img src={p1} alt="Knitted Hat" />
                        <p>Knitted Hat by Alex</p>
                    </div>
                    <div className="photo-card">
                        <img src={p2} alt="Crochet Blanket" />
                        <p>Cozy Crochet Blanket by Samantha</p>
                    </div>
                    <div className="photo-card">
                        <img src={p3} alt="Woven Tapestry" />
                        <p>Woven Tapestry by Rebecca</p>
                    </div>
                </div>
            </section>

            <div className="feedback-footer">
                <p>Want to share your story? Join our community and be featured!</p>
            </div>
        </div>
    );
}

export default Feedback;
